const userRoles = {
  USER: 'USER',
  COURSE_CREATOR: 'COURSE_CREATOR',
  SUPERADMIN: 'SUPERADMIN',
  CREATOR: 'CREATOR',
  ENTERPRISE: 'ENTERPRISE',
  BUSINESS: 'BUSINESS',
  MEMBER: 'MEMBER',
};

export default userRoles;
